export default `/* Ids Pager Number List Component */
:host(ids-pager-number-list) {
  box-sizing: border-box;
  flex-basis: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  text-align: center;
}

ids-button {
  vertical-align: initial;
}

ids-button::part(button) {
  max-width: var(--ids-space-xl);
  padding: 6px var(--ids-space-xs);
}

ids-button:not([selected]):not([disabled])::part(button) {
  color: var(--ids-hyperlink-color-text-default);
}

ids-button[selected]::part(button) {
  font-weight: var(--ids-font-weight-semibold);
}

ids-button:not([selected]):hover {
  border: none;
  border-bottom: 1px solid var(--ids-color-border-focus);
}

.divider {
  display: inline-flex;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtcGFnZXIiLCJzb3VyY2VzIjpbImlkcy1wYWdlci1udW1iZXItbGlzdC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIFBhZ2VyIE51bWJlciBMaXN0IENvbXBvbmVudCAqL1xuOmhvc3QoaWRzLXBhZ2VyLW51bWJlci1saXN0KSB7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIGZsZXgtYmFzaXM6IDA7XG4gIGZsZXgtc2hyaW5rOiAwO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuXG5pZHMtYnV0dG9uIHtcbiAgdmVydGljYWwtYWxpZ246IGluaXRpYWw7XG59XG5cbmlkcy1idXR0b246OnBhcnQoYnV0dG9uKSB7XG4gIG1heC13aWR0aDogdmFyKC0taWRzLXNwYWNlLXhsKTtcbiAgcGFkZGluZzogNnB4IHZhcigtLWlkcy1zcGFjZS14cyk7XG59XG5cbmlkcy1idXR0b246bm90KFtzZWxlY3RlZF0pOm5vdChbZGlzYWJsZWRdKTo6cGFydChidXR0b24pIHtcbiAgY29sb3I6IHZhcigtLWlkcy1oeXBlcmxpbmstY29sb3ItdGV4dC1kZWZhdWx0KTtcbn1cblxuaWRzLWJ1dHRvbltzZWxlY3RlZF06OnBhcnQoYnV0dG9uKSB7XG4gIGZvbnQtd2VpZ2h0OiB2YXIoLS1pZHMtZm9udC13ZWlnaHQtc2VtaWJvbGQpO1xufVxuXG5pZHMtYnV0dG9uOm5vdChbc2VsZWN0ZWRdKTpob3ZlciB7XG4gIGJvcmRlcjogbm9uZTtcbiAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkIHZhcigtLWlkcy1jb2xvci1ib3JkZXItZm9jdXMpO1xufVxuXG4uZGl2aWRlciB7XG4gIGRpc3BsYXk6IGlubGluZS1mbGV4O1xufVxuIl19 */`;
